import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid
} from "@mui/material";
import Breadcrumb from "../components/Breadcrumb";
import Cards from "../components/Cards";
import f1 from "../assests/f1.png";
import f2 from "../assests/f2.png";
import f3 from "../assests/f3.png";
import f4 from "../assests/f4.png";
import f5 from "../assests/f5.png";
import f6 from "../assests/f6.png";

const FeatureSection = () => {
  const vendorDetails = [
    {
      image: f1,
      title: "Quality First",
      description: `We deliver safe, reliable, and high-performing medical products that healthcare professionals can trust.`,
    },
    {
      image: f2,
      title: "Integrity & Compliance",
      description: `We uphold the highest standards of accountability, ensuring adherence to U.S. and international regulations, including FDA requirements.`,
    },
    {
      image: f3,
      title: "Partnership & Collaboration",
      description: `We build long-term relationships with healthcare providers, distributors, and manufacturers, fostering mutual growth and shared trust.`,
    },
    {
      image: f4,
      title: "Accessibility & Affordability",
      description: `By reducing import duties and streamlining distribution, we make essential medical products more accessible and cost-effective for the U.S. healthcare system.`,
    },
    {
      image: f5,
      title: "Innovation with Purpose",
      description: `We integrate advanced technologies and data-driven solutions to enhance production efficiency, compliance, and patient outcomes.`,
    },
    {
      image: f6,
      title: "Global Responsibility",
      description: `We strengthen economic opportunities in Jordan while ensuring U.S. healthcare providers receive the quality supplies they need to serve communities nationwide.`,
    },
  ];


  return (
    <>
      <Box sx={{ padding: "60px 0", background: "#F5F8FA" }}>
        <Container maxWidth="xl">
          <Typography
            className="titleSec"
            sx={{
              marginBottom: "50px",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              "& span": {
                fontFamily: `"Quicksand", sans-serif`,
                fontWeight: 700,
                lineHeight: "24px",
                fontSize: { xs: "16px", md: "22px", lg: "24px" },
                color: "#008BFF",
                textAlign: "center",
              },
            }}
          >
            <span>Core Values</span>
          </Typography>
          <Grid container spacing={2} sx={{display: "grid", alignItems: "center",gridTemplateColumns:"repeat(3, 1fr)",gap:"40px",}}>
            {vendorDetails.map((vendorDetail, index) => (
              <Grid
                item
                // size={{ xs: 12, sm: 6, md: 4, lg: 4 }}
                sx={{
                  "& .cardBox": {
                    border: "none",
                  },
                  width:"100%", 
                  height:"100%"
                }}
                key={index}
              >
                <Cards
                  key={index}
                  displayImage={false}
                  title={vendorDetail?.title}
                  description={vendorDetail?.description}
                  image={vendorDetail.image}
                  buttonText="Read More"
                  buttonTextUrl="#"
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default FeatureSection;